import { Request, Response } from 'kts-scaffold-framework/server';
import { CallType } from 'kts-scaffold-framework/utils/ajax';
import { Urls } from 'kts-platform-frame/entry/constant';
import ApiBasic from 'kts-platform-frame/api/ApiBasic';
import IData from './IData';
import IOptions from './IOptions';

/**
 * 忘记密码
 */
class ResetPwdDo extends ApiBasic<IOptions, IData> {
    public async api(option: IOptions): Promise<Response<IData>> {
        const req: Request = new Request(CallType.POST, Urls.LOGIN_FORGET_DO, option);

        // 屏蔽自动提示
        req.isMessage = false;

        let data: Response<any> = await this.callAjax(req);
        return data;
    }
}

export default new ResetPwdDo().run;



// WEBPACK FOOTER //
// ./src/api/login/resetPwdDo/index.ts